import { Autocomplete, styled } from '@mui/material'

export const AutocompleteCustomStyle = styled(Autocomplete)({
  '&.Mui-focused': {
    '& .MuiAutocomplete-input': {
      minWidth: '50%!important',
    },
  },
  '& .MuiAutocomplete-input': {
    margin: '0 8px',
    '.MuiTypography-caption + &': {
      maxWidth: '10px!important',
    },
  },
  '&:not(.show-chips) .MuiAutocomplete-inputRoot': {
    flexWrap: 'nowrap',
    overflow: 'visible',
    '& .MuiTypography-caption': {
      lineHeight: 1,
    },
  },
})
